import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';
import { BrandMarkLarge } from '@/components/Logo';

export default function AuthCallback() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [msg, setMsg] = useState('Prihlásujem...');

  useEffect(() => {
    let mounted = true;
    const tick = async () => {
      // Supabase JS auto-detects URL params; just wait a bit
      const { data } = await supabase.auth.getSession();
      if (!mounted) return;
      if (data.session) {
        // Check workspace
        const { data: ws } = await supabase
          .from('workspaces')
          .select('id')
          .eq('user_id', data.session.user.id)
          .limit(1);
        if (!mounted) return;
        if (ws && ws.length > 0) navigate('/', { replace: true });
        else navigate('/onboarding', { replace: true });
      } else {
        // No session yet, retry once
        setTimeout(async () => {
          const { data: d2 } = await supabase.auth.getSession();
          if (!mounted) return;
          if (d2.session) {
            navigate('/', { replace: true });
          } else {
            setMsg('Magic link expiroval alebo sa nepodarilo prihlásiť. Pôjdem na prihlasovaciu stránku.');
            setTimeout(() => navigate('/login', { replace: true }), 1500);
          }
        }, 1200);
      }
    };
    tick();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 18,
    }}>
      <BrandMarkLarge size={64} />
      <span className="cd-spinner" />
      <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>{msg}</div>
    </div>
  );
}
